import { z } from 'zod'

/**
 * Coerce unknown input into a number or null.
 * Useful for ReactHookForm validation to treat empty strings as null.
 */
export const coerceNullableNumber = (val: unknown): number | null => {
  return z.union([z.null(), z.coerce.number()]).catch(null).parse(val)
}

/**
 * Coerce unknown input into a Date or unknown.
 * Useful for deserializing string dates from inngest serialization.
 */
export const coerceDate = (val: unknown) => {
  if (typeof val === 'string' || val instanceof Date) {
    const date = new Date(val)

    if (!Number.isNaN(date.getTime())) {
      return date
    }
  }
  return val
}
